import { Box } from "@mui/material";
import { HeadingL, Icons } from "@repo/ui";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { InternalButtonLink } from "../Link";
import ContactBox from "./ContactBox";

const General: FC = () => {
    const { t } = useTranslation();
    return (
        <Box mb={6}>
            <HeadingL withoutScale>{t("topbar.contactCard.heading")}</HeadingL>
            <ContactBox
                title={t("topbar.contactCard.titlePhone")}
                description={t("topbar.contactCard.descriptionPhone")}
                link={
                    <InternalButtonLink
                        to={`tel:${t("topbar.contactCard.phoneNumber")}`}
                        variant="text"
                        size="small"
                        startIcon={<Icons.Phone sx={{ width: "1.1rem", height: "1.6rem" }} />}
                    >
                        {t("topbar.contactCard.phoneNumber")}
                    </InternalButtonLink>
                }
                mb={5}
            />
            <ContactBox
                title={t("topbar.contactCard.titleEmail")}
                description={t("topbar.contactCard.descriptionEmail")}
                link={
                    <InternalButtonLink
                        to={`mailto:${t("topbar.contactCard.emailAddress")}`}
                        variant="text"
                        size="small"
                        startIcon={<Icons.Envelope sx={{ width: "1.4rem", height: "1rem" }} />}
                    >
                        {t("topbar.contactCard.emailAddress")}
                    </InternalButtonLink>
                }
            />
        </Box>
    );
};
export default General;
